import React from "react";
import { FiBookOpen, FiCalendar, FiMapPin, FiUser } from "react-icons/fi";
import { formatSchedule } from "./StudentClassSchedule";

const getDisplay = (value, fallback = "—") => {
  if (!value) return fallback;
  if (typeof value === "string") return value;
  if (typeof value === "object") return value.vi || value.en || fallback;
  return String(value);
};

export default function StudentClassHeader({ selectedClass, program, assignmentCount = 0 }) {
  if (!selectedClass) {
    return (
      <div className="rounded-2xl border bg-gradient-to-r from-blue-50 to-indigo-50 p-5">
        <h2 className="text-xl font-bold text-slate-900">Tất cả lớp học</h2>
        <p className="mt-1 text-slate-600">Xem toàn bộ bài tập/kiểm tra được giao từ các lớp bạn đang tham gia.</p>
        <div className="mt-4 inline-flex rounded-full bg-white px-3 py-1 text-sm font-medium text-blue-700 border border-blue-100">
          {assignmentCount} bài tập/kiểm tra
        </div>
      </div>
    );
  }

  const teachers = Array.isArray(selectedClass.teachers) && selectedClass.teachers.length
    ? selectedClass.teachers.map((t) => t.display?.name || t.display?.email || t.uid || t.id).join(", ")
    : "Chưa cập nhật";

  return (
    <div className="rounded-2xl border bg-gradient-to-r from-blue-50 to-indigo-50 p-5">
      <div className="flex flex-col lg:flex-row lg:items-start lg:justify-between gap-4">
        <div>
          <div className="inline-flex items-center gap-2 rounded-full bg-white px-3 py-1 text-xs font-semibold text-blue-700 border border-blue-100">
            <FiBookOpen /> {getDisplay(program?.name || program?.title || program?.level || selectedClass.programName || selectedClass.programId, "Lớp học")}
          </div>
          <h2 className="mt-3 text-2xl font-bold text-slate-900">{getDisplay(selectedClass.name, "Lớp học")}</h2>
          {selectedClass.description && (
            <p className="mt-1 text-slate-600 line-clamp-2">{getDisplay(selectedClass.description)}</p>
          )}
        </div>

        <div className="rounded-2xl bg-white/80 p-3 text-sm text-slate-700 border border-white">
          <div className="flex items-center gap-2 mb-1"><FiUser /> {teachers}</div>
          <div className="flex items-center gap-2 mb-1"><FiMapPin /> {selectedClass.room || "Chưa cập nhật phòng"}</div>
          <div className="flex items-center gap-2"><FiCalendar /> {formatSchedule(selectedClass.schedule)}</div>
        </div>
      </div>
    </div>
  );
}
